// extracted by mini-css-extract-plugin
export default {"move":"Move_move__aBwUY"};